import { dateTimeForXGrid, isValidDate } from '@sales-center/common'
import { GridValueFormatterParams } from '@mui/x-data-grid-pro'

export const dateTimeValueFormatter = ({ value }: GridValueFormatterParams) => {
  if (!!value) {
    const date = typeof value === 'string' ? new Date(value) : value
    if (isValidDate(date)) return dateTimeForXGrid(date)
  }
  return null
}
